// import { useEffect, useMemo, useState, useCallback } from "react";
// import { NavLink, useParams, useLocation } from "react-router-dom";
// import { ChevronDown, Menu } from "lucide-react";
// import { Typography, Tooltip } from "@mui/material";
// import clsx from "clsx";
// import {
//   FaReply,
//   FaReplyAll,
//   FaHome,
//   FaRegCalendarCheck,
//   FaWalking,
//   FaClipboardCheck,
//   FaRegEyeSlash,
//   FaEnvelopeOpenText,
//   FaFileInvoice,
//   FaQuestionCircle,
//   FaInbox,
// } from "react-icons/fa";
// import CustomNavLink from "../custom/CustomNavLink";

// const iconMap = {
//   first_follow_up: <FaReply className="text-blue-500" />,
//   last_follow_up: <FaReplyAll className="text-purple-500" />,
//   "move-in_check-in": <FaHome className="text-green-500" />,
//   "renewal_check-in": <FaRegCalendarCheck className="text-yellow-500" />,
//   want_to_tour: <FaWalking className="text-indigo-500" />,
//   book_tour: <FaClipboardCheck className="text-pink-500" />,
//   left_on_read: <FaRegEyeSlash className="text-red-500" />,
//   unread: <FaEnvelopeOpenText className="text-orange-500" />,
//   invoice_info: <FaFileInvoice className="text-gray-500" />,
//   default: <FaQuestionCircle className="text-gray-400" />,
// };

// export default function LeftSidePanel({ categoryList = [] }) {
//   const params = useParams();
//   const location = useLocation();

//   const [openCategory, setOpenCategory] = useState([]);
//   const [allExpanded, setAllExpanded] = useState(true);
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const groupedCategories = useMemo(() => {
//     const grouped = Object.groupBy(categoryList, (cat) => cat.group || "Others");
//     return Object.entries(grouped).map(([group, subCategory]) => ({
//       key: group.replace(/\s+/g, "-").toLowerCase(),
//       header: group,
//       subCategory,
//     }));
//   }, [categoryList]);

//   const allKeys = useMemo(() => groupedCategories.map((g) => g.key), [groupedCategories]);

//   useEffect(() => {
//     setOpenCategory(allKeys);
//     setAllExpanded(true);
//   }, [allKeys]);

//   const toggleCategory = (key) => {
//     setOpenCategory((prev) =>
//       prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
//     );
//   };

//   const handleToggleAll = () => {
//     if (allExpanded) {
//       setOpenCategory([]);
//       setAllExpanded(false);
//     } else {
//       setOpenCategory(allKeys);
//       setAllExpanded(true);
//     }
//   };

//   const toggleCollapsed = () => setIsCollapsed((prev) => !prev);

//   // Keyboard shortcut Ctrl+B to toggle sidebar
//   useEffect(() => {
//     const onKeyDown = (e) => {
//       if (e.ctrlKey && e.key.toLowerCase() === "b") {
//         e.preventDefault();
//         toggleCollapsed();
//       }
//     };
//     window.addEventListener("keydown", onKeyDown);
//     return () => window.removeEventListener("keydown", onKeyDown);
//   }, []);

//   const isViewAllActive = location.pathname.startsWith("/conversations/all/chats");

//   return (
//     // <aside
//     //   className={clsx(
//     //     "transition-all duration-300 ease-in-out border-r shadow-md sticky top-16 h-[calc(100vh-64px)] z-10 bg-white overflow-y-auto",
//     //     isCollapsed ? "w-16" : "w-64 p-4"
//     //   )}
//     // >
//     <aside
//   className={clsx(
//     "overflow-y-auto border-r shadow-md sticky top-16 h-[calc(100vh-64px)] z-10 bg-white",
//     "transition-all ease-in-out duration-300",
//     isCollapsed
//       ? "w-16 animate-collapseSidebar"
//       : "w-64 p-4 animate-expandSidebar"
//   )}
// >

//       {/* Top row: Hamburger icon */}
//       <div className={clsx("flex", isCollapsed ? "justify-center px-2 pt-4 pb-2" : "justify-end mb-4")}>
//         <button
//           onClick={toggleCollapsed}
//           className="text-blue-600 hover:bg-blue-50 p-2 rounded"
//           title={isCollapsed ? "Expand Sidebar (Ctrl+B)" : "Collapse Sidebar (Ctrl+B)"}
//         >
//           <Menu size={20} />
//         </button>
//       </div>

//       {/* Second row: View All + (optional Collapse All) */}
//       {!isCollapsed ? (
//         <div className="flex justify-between items-center mb-4">
//           <NavLink
//             to="/conversations/all/chats"
//             className={clsx(
//               "font-medium px-2 py-1 rounded transition flex items-center",
//               isViewAllActive
//                 ? "bg-blue-100 text-blue-700 font-semibold"
//                 : "text-gray-700 hover:text-blue-600 hover:bg-gray-100"
//             )}
//           >
//             <FaInbox className="mr-2" />
//             View All
//           </NavLink>

//           <button
//             onClick={handleToggleAll}
//             className="text-xs text-blue-600 hover:underline font-medium"
//           >
//             {allExpanded ? "Collapse All" : "Expand All"}
//           </button>
//         </div>
//       ) : (
//         <div className="flex flex-col items-center gap-4 mt-4">
//           <Tooltip title="View All" placement="right">
//             <NavLink
//               to="/conversations/all/chats"
//               className={clsx(
//                 "p-2 rounded hover:bg-gray-100 transition transform duration-200 hover:scale-105",
//                 isViewAllActive
//                   ? "bg-blue-100 text-blue-700"
//                   : "text-gray-700 hover:text-blue-600"
//               )}
//             >
//               <FaInbox />
//             </NavLink>
//           </Tooltip>
//         </div>
//       )}

//       {/* Category sections */}
//       {groupedCategories.map((group) => {
//         const isOpen = openCategory.includes(group.key);

//         return (
//           <div key={group.key} className="mb-2">
//             {!isCollapsed ? (
//               <>
//                 {/* Group Header */}
//                 <button
//                   onClick={() => toggleCategory(group.key)}
//                   className="w-full flex justify-between items-center px-2 py-2 bg-gray-100 hover:bg-gray-200 rounded"
//                 >
//                   <Typography variant="subtitle2" className="text-left font-medium">
//                     {group.header}
//                   </Typography>
//                   <ChevronDown
//                     className={clsx(
//                       "w-4 h-4 transform transition-transform",
//                       isOpen && "rotate-180"
//                     )}
//                   />
//                 </button>

//                 {/* Subcategories (Expanded view) */}
//                 {isOpen && (
//                   <ul className="mt-2 space-y-1 pl-4 pr-2 text-sm">
//                     {group.subCategory.map((sub) => {
//                       const isActive = params.category === sub.name;
//                       return (
//                         <NavLink
//                           key={sub.id}
//                           to={`/conversations/${sub.name}`}
//                           className={({ isActive }) =>
//                             clsx(
//                               "flex items-center justify-between px-2 py-1 rounded transition",
//                               isActive || isActive
//                                 ? "bg-blue-100 text-blue-700 font-semibold"
//                                 : "hover:bg-gray-100 hover:text-blue-600"
//                             )
//                           }
//                         >
//                           <div className="flex items-center truncate">
//                             {iconMap[sub.name] ?? iconMap.default}
//                             <span className="truncate ml-2">{sub.label}</span>
//                           </div>
//                           {sub.count > 0 && (
//                             <span className="text-xs bg-blue-500 text-white px-2 py-0.5 rounded-full">
//                               {sub.count}
//                             </span>
//                           )}
//                         </NavLink>
//                       );
//                     })}
//                   </ul>
//                 )}
//               </>
//             ) : (
//               <ul className="flex flex-col items-center space-y-4 mt-4">
//                 {group.subCategory.map((sub) => {
//                   const isActive = params.category === sub.name;
//                   return (
//                     <Tooltip key={sub.id} title={sub.label} placement="right">
//                       <CustomNavLink
//                         to={`/conversations/${sub.name}`}
//                         className={clsx(
//                           "p-2 rounded transition transform duration-200 hover:scale-105 hover:bg-gray-100",
//                           isActive
//                             ? "bg-blue-100 text-blue-700"
//                             : "text-gray-700 hover:text-blue-600"
//                         )}
//                         title={sub.label}
//                       >
//                         {iconMap[sub.name] ?? iconMap.default}
//                       </CustomNavLink>
//                     </Tooltip>
//                   );
//                 })}
//               </ul>
//             )}
//           </div>
//         );
//       })}
//     </aside>
//   );
// }


import { useEffect, useMemo, useState } from "react";
import { NavLink, useParams, useLocation } from "react-router-dom";
import { ChevronDown, Menu, RefreshCcw } from "lucide-react";
import { Typography, Tooltip } from "@mui/material";
import clsx from "clsx";
import {
  FaReply, FaReplyAll, FaHome, FaRegCalendarCheck,
  FaWalking, FaClipboardCheck, FaRegEyeSlash,
  FaEnvelopeOpenText, FaFileInvoice, FaQuestionCircle, FaInbox,
  FaMoneyCheckAlt,
  FaStickyNote,
} from "react-icons/fa";
import CustomNavLink from "../custom/CustomNavLink";
import { messageCategory } from "../../constants/message.catergory";

const iconMap = {
  [messageCategory.followUp]: <FaReply className="text-blue-500" />,
  [messageCategory.tourFollowUp]: <FaReplyAll className="text-purple-500" />,
  [messageCategory.moveInCheckIn]: <FaHome className="text-teal-500" />,
  [messageCategory.renewalCheckIn]: <FaRegCalendarCheck className="text-lime-500" />,
  [messageCategory.renewalCheckInNoClient]: <FaRegCalendarCheck className="text-gray-400" />,
  [messageCategory.sharedUnitsNotes]: <FaStickyNote className="text-yellow-400" />,
  [messageCategory.tourCheck]: <FaWalking className="text-indigo-500" />,
  [messageCategory.paidCheckIn]: <FaMoneyCheckAlt className="text-yellow-500" />,
  [messageCategory.bookTour]: <FaClipboardCheck className="text-pink-500" />,
  [messageCategory.leftOnRead]: <FaRegEyeSlash className="text-red-500" />,
  [messageCategory.unread]: <FaEnvelopeOpenText className="text-orange-500" />,
  [messageCategory.invoiceInfo]: <FaFileInvoice className="text-amber-500" />,
  default: <FaQuestionCircle className="text-gray-400" />,
};

export default function LeftSidePanel({ categoryList = [], isLoading, onRefresh, error }) {
  const params = useParams();
  const location = useLocation();
  const [openCategory, setOpenCategory] = useState([]);
  const [allExpanded, setAllExpanded] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const groupedCategories = useMemo(() => {
    const grouped = Object.groupBy(categoryList, (cat) => cat.group || "Others");
    return Object.entries(grouped).map(([group, subCategory]) => ({
      key: group.replace(/\s+/g, "-").toLowerCase(),
      header: group,
      subCategory,
    }));
  }, [categoryList]);

  const isViewAllActive = location.pathname.startsWith("/conversations/all/chats");
  const allKeys = useMemo(() => groupedCategories.map((g) => g.key), [groupedCategories]);

  useEffect(() => {
    setOpenCategory(allKeys);
    setAllExpanded(true);
  }, [allKeys]);


  const handleToggleAll = () => {
    if (allExpanded) {
      setOpenCategory([]);
      setAllExpanded(false);
    } else {
      setOpenCategory(allKeys);
      setAllExpanded(true);
    }
  };

  const toggleCategory = (key) => {
    setOpenCategory((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const toggleCollapsed = () => setIsCollapsed((prev) => !prev);

  // Keyboard shortcut Ctrl+B to toggle sidebar
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "b") {
        e.preventDefault();
        toggleCollapsed();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <aside className={clsx(
      "border-r shadow-md sticky top-16 h-[calc(100vh-64px)] bg-white overflow-y-auto z-10 transition-all duration-300",
      isCollapsed ? "w-16" : "w-64 p-4"
    )}>
      {/* Hamburger */}
      {/* <div className={clsx(isCollapsed ? "flex justify-center py-3" : "flex justify-end mb-4")}>
        <button onClick={() => setIsCollapsed(!isCollapsed)} className="p-2 text-blue-600 hover:bg-blue-50 rounded" title="Toggle Sidebar (Ctrl+B)">
          <Menu size={20}/>
        </button>
      </div> */}
      {/* Top row: Hamburger icon */}
       <div className={clsx("flex", isCollapsed ? "justify-center px-2 pt-4 pb-2" : "justify-end mb-4")}>
         <button
           onClick={toggleCollapsed}
           className="text-blue-600 hover:bg-blue-50 p-2 rounded"
           title={isCollapsed ? "Expand Sidebar (Ctrl+B)" : "Collapse Sidebar (Ctrl+B)"}
         >
           <Menu size={20} />
         </button>
       </div>

      {/* View All + Refresh */}
      {!isCollapsed ? (
        <div className="flex justify-between items-center mb-4">
          <NavLink
            to="/conversations/all/chats"
            className={clsx("flex items-center px-2 py-1 rounded font-medium transition",
              isViewAllActive ? "bg-blue-100 text-blue-700" : "text-gray-700 hover:bg-gray-100 hover:text-blue-600"
            )}
          >
            <FaInbox className="mr-2"/>
            View All
          </NavLink>

          <button
            onClick={onRefresh}
            disabled={isLoading}
            className="text-xs text-blue-600 hover:underline disabled:opacity-50"
            title="Refresh"
          >
             <RefreshCcw size={16} />
          </button>
          <button
            onClick={handleToggleAll}
            className="text-xs text-blue-600 hover:underline font-medium"
          >
            {allExpanded ? "Collapse All" : "Expand All"}
          </button>
        </div>
      ) : (
        <div className="flex justify-center mt-4 space-x-2">
          <Tooltip title="View All"><NavLink to="/conversations/all/chats"><FaInbox className={isViewAllActive ? "text-blue-600" : "text-gray-700"} /></NavLink></Tooltip>
          {/* <Tooltip title="Refresh Categories"><button onClick={onRefresh} disabled={isLoading} className="text-gray-700 hover:text-blue-600 disabled:opacity-50">⟳</button></Tooltip> */}
        </div>
      )}

      {/* Error / Skeleton */}
      {error && !isLoading && (
        <div className="px-3 py-2 text-red-500 text-sm">
          Failed to load categories.
          <button onClick={onRefresh} className="ml-2 text-blue-600 hover:underline">Retry</button>
        </div>
      )}
      {isLoading && !error && (
        <div className="space-y-2 animate-pulse px-2">
          <div className="h-4 bg-gray-300 rounded"></div>
          <div className="h-4 bg-gray-300 rounded"></div>
        </div>
      )}

      {/* Category List */}
      {/* {!isCollapsed && groupedCategories.map(group => (
        <div key={group.key} className="mb-2">
          <button
            //onClick={() => setOpenCategory(prev => prev.includes(group.key) ? prev.filter(k => k !== group.key) : [...prev, group.key])}
            onClick={() => toggleCategory(group.key)}
            className="flex w-full justify-between px-2 py-2 bg-gray-100 hover:bg-gray-200 rounded">
            <Typography variant="subtitle2">{group.header}</Typography>
            <ChevronDown className={clsx("w-4 h-4 transform transition-transform", openCategory.includes(group.key) && "rotate-180")} />
          </button>
          {openCategory.includes(group.key) && (
            <ul className="mt-2 space-y-1 pl-4 pr-2 text-sm">
              {group.subcats.map(sub => (
                <NavLink
                  key={sub.id}
                  to={`/conversations/${sub.name}`}
                  className={({ isActive }) => clsx("flex items-center justify-between px-2 py-1 rounded transition",
                    isActive ? "bg-blue-100 text-blue-700 font-semibold" : "hover:bg-gray-100 hover:text-blue-600"
                  )}
                >
                  <div className="flex items-center truncate">
                    {iconMap[sub.name] || iconMap.default}
                    <span className="truncate ml-2">{sub.label}</span>
                  </div>
                  {sub.count > 0 && <span className="text-xs bg-blue-500 text-white px-2 rounded-full">{sub.count}</span>}
                </NavLink>
              ))}
            </ul>
          )}
        </div>
      ))} */}

      {/* Collapsed icons view */}
      {/* {isCollapsed && groupedCategories?.map(group => (
        <ul key={group.key} className="flex flex-col items-center space-y-4 mt-4">
          {group.subcats.map(sub => (
            <Tooltip key={sub.id} title={sub.label} placement="right">
              <NavLink to={`/conversations/${sub.name}`} className="p-2 rounded hover:bg-gray-100 transition-transform hover:scale-105">
                {iconMap[sub.name] || iconMap.default}
              </NavLink>
            </Tooltip>
          ))}
        </ul>
      ))} */}
            {/* Category sections */}
      {!isLoading && groupedCategories.map((group) => {
        const isOpen = openCategory.includes(group.key);

        return (
          <div key={group.key} className="mb-2">
            {!isCollapsed ? (
              <>
                {/* Group Header */}
                <button
                  onClick={() => toggleCategory(group.key)}
                  className="w-full flex justify-between items-center px-2 py-2 bg-gray-100 hover:bg-gray-200 rounded"
                >
                  <Typography variant="subtitle2" className="text-left font-medium">
                    {group.header}
                  </Typography>
                  <ChevronDown
                    className={clsx(
                      "w-4 h-4 transform transition-transform",
                      isOpen && "rotate-180"
                    )}
                  />
                </button>

                {/* Subcategories (Expanded view) */}
                {isOpen && (
                  <ul className="mt-2 space-y-1 pl-4 pr-2 text-sm">
                    {group.subCategory.map((sub) => {
                      const isActive = params.category === sub.name;
                      return (
                        <NavLink
                          key={sub.id}
                          to={`/conversations/${sub.name}`}
                          className={({ isActive }) =>
                            clsx(
                              "flex items-center justify-between px-2 py-1 rounded transition",
                              isActive || isActive
                                ? "bg-blue-100 text-blue-700 font-semibold"
                                : "hover:bg-gray-100 hover:text-blue-600"
                            )
                          }
                        >
                          <div className="flex items-center truncate">
                            {iconMap[sub.name] ?? iconMap.default}
                            <span className="truncate ml-2">{sub.label}</span>
                          </div>
                          {sub.count > 0 && (
                            <span className="text-xs bg-blue-500 text-white px-2 py-0.5 rounded-full">
                              {sub.count}
                            </span>
                          )}
                        </NavLink>
                      );
                    })}
                  </ul>
                )}
              </>
            ) : (
              <ul className="flex flex-col items-center space-y-4 mt-4">
                {group.subCategory.map((sub) => {
                  const isActive = params.category === sub.name;
                  return (
                    <Tooltip key={sub.id} title={sub.label} placement="right">
                      <CustomNavLink
                        to={`/conversations/${sub.name}`}
                        className={clsx(
                          "p-2 rounded transition transform duration-200 hover:scale-105 hover:bg-gray-100",
                          isActive
                            ? "bg-blue-100 text-blue-700"
                            : "text-gray-700 hover:text-blue-600"
                        )}
                        title={sub.label}
                      >
                        {iconMap[sub.name] ?? iconMap.default}
                      </CustomNavLink>
                    </Tooltip>
                  );
                })}
              </ul>
            )}
          </div>
        );
      })}

      
    </aside>
  );
}
